import { generators } from '@playcastdotio/Messaging';
import { ipcSend } from '../../../../api/messaging/protocols/ipc';
import type { ParsedTouchStep } from '../MacroStepParser';

export class MacroTouchEmitter {
  public async sendTouchAction(step: ParsedTouchStep): Promise<void> {
    const touchData = {
      changedTouches: [
        {
          identifier: step.touchId ?? 0,
          screenX: 0,
          screenY: 0,
          relativeX: step.x,
          relativeY: step.y,
          force: step.action === 'up' ? 0 : 1,
        },
      ],
      altKey: false,
      ctrlKey: false,
      metaKey: false,
      shiftKey: false,
    };

    switch (step.action) {
      case 'down':
        ipcSend(generators.touch.start('host', touchData));
        break;
      case 'move':
        ipcSend(generators.touch.move('host', touchData));
        break;
      case 'up':
        ipcSend(generators.touch.end('host', touchData));
        break;
    }
  }
}
